let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g7amP")).then(() => parcelRequire('gtN4u'));